import ArchievedList from '../../components/deal/archieved_list';
import AutomationBuilderComponent from '../../components/automation/builder';
import AutomationComponent from '../../components/automation';
import CardWrapper from '../../components/wrapper/card';
import DealDetails from '../../components/deal/detail';
import EditDeal from '../../components/deal/edit';
import EmailAndSMSComponent from '../../components/deal/email_and_sms';
import PipelineComponent from '../../components/pipeline';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { a11yProps, CustomTabPanel } from '../deals';
import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';

const SalesAndMarketingPage = () => {
  const [value, setValue] = useState(0);
  const { flags: DealFlags } = useSelector((state: RootState) => state.deal);
  const { flags: AutomationFLags, selectedAutomation } = useSelector((state: RootState) => state.automation);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (DealFlags.showEmailAndSMS !== null) {
    return <Box pb="100px"><EmailAndSMSComponent /></Box>;
  } else if (DealFlags.viewDetail && !DealFlags.editDeal) {
    return <Box pb="100px"><DealDetails /></Box>;
  } else if (DealFlags.editDeal) {
    return <Box pb="100px"><EditDeal /></Box>;
  } else if (AutomationFLags.showBuilder && selectedAutomation) {
    return <Box pb="100px"><AutomationBuilderComponent /></Box>;
  }

  return (
    <CardWrapper minHeight="80vh" overflow="auto" sx={{ pb: '100px' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="pipeline details tabs"
      // TabIndicatorProps={{
      //   style: { backgroundColor: 'var(--primary-color)" },
      // }}
      // sx={{
      //   "& .MuiTab-root.Mui-selected": { color: "var(--primary-color)" },
      // }}
      >
        <Tab
          label="Pipeline"
          {...a11yProps(0)}
        />
        <Tab
          label="Automation"
          {...a11yProps(1)}
        />
      </Tabs>

      <CustomTabPanel value={value} index={0}>
        {DealFlags.showArchievedList ? <ArchievedList /> : <PipelineComponent />}
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <AutomationComponent />
      </CustomTabPanel>
    </CardWrapper>
  );
};

export default SalesAndMarketingPage;